import { render } from "./ProfileStats.vue?vue&type=template&id=a07c56fc&scoped=true"
import script from "./ProfileStats.vue?vue&type=script&lang=js"
export * from "./ProfileStats.vue?vue&type=script&lang=js"

import "./ProfileStats.vue?vue&type=style&index=0&id=a07c56fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a07c56fc"]])

export default __exports__